@if (control) {
    <div [ngClass]="question.styles">
        <mat-checkbox
            [formControl]="control"
            class="ca-checkbox"
            [disableRipple]="true"
            [id]="question.key"
            [attr.data-testid]="question.key"
        >
            {{ question.label | translate }}
        </mat-checkbox>
        @if (question.validators.length) {
            <div class="ca-subscript relative mt-2">
                @if (isInvalid && isTouched) {
                    <div class="absolute ca-error-message" @slideDown>
                        <ca-form-error-message>
                            {{ errorMessage | translate }}
                        </ca-form-error-message>
                    </div>
                }
            </div>
        }
    </div>
}
